/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * One seller-shared listing document on the anonymous offer form.
 * 
 * Deliberately narrower than `MtxDocResponse`: enough to name the file and link to the
 * public download route, nothing about provenance, review state or storage. `mime_type` is
 * the FROZEN one captured at share time, matching the bytes the download route serves.
 * @export
 * @interface PublicSharedDocumentResponse
 */
export interface PublicSharedDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof PublicSharedDocumentResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSharedDocumentResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSharedDocumentResponse
     */
    docTypeDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSharedDocumentResponse
     */
    mimeType?: string;
}

/**
 * Check if a given object implements the PublicSharedDocumentResponse interface.
 */
export function instanceOfPublicSharedDocumentResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function PublicSharedDocumentResponseFromJSON(json: any): PublicSharedDocumentResponse {
    return PublicSharedDocumentResponseFromJSONTyped(json, false);
}

export function PublicSharedDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicSharedDocumentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'docTypeDisplayName': !exists(json, 'doc_type_display_name') ? undefined : json['doc_type_display_name'],
        'mimeType': !exists(json, 'mime_type') ? undefined : json['mime_type'],
    };
}

export function PublicSharedDocumentResponseToJSON(value?: PublicSharedDocumentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'doc_type_display_name': value.docTypeDisplayName,
        'mime_type': value.mimeType,
    };
}

